export default __webpack_public_path__ + "static/media/img1.5de1acf4.svg";